import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { BsFillCircleFill } from '@react-icons/all-files/bs/BsFillCircleFill';
import { Contract } from '../Utils/Contract';
import { Enums } from '../Utils/Enums';
import { Tooltip } from './Tooltip';

export interface IServicesAlertProps {
    readonly contract: Contract | undefined;
    onClick?(): void;
    readonly display?: {
        shippedDate?: Date;
        partStatus?: { partState: Mri.PartStatus.PartState };
    };
    readonly className?: string;
    readonly type?: 'dot' | 'message';
    readonly isPortal?: boolean;
}

@observer
export class ServicesAlert extends React.Component<IServicesAlertProps> {
    public render() {
        const { type, className } = this.props;
        switch (type) {
            default:
            case 'dot':
                return (
                    <Tooltip message={this.message} className='d-inline-block'>
                        <a onClick={this.props.onClick} className='d-inline-block'>
                            <BsFillCircleFill className={`warranty-dot d-flex ${className} ${this.iconClass}`} />
                        </a>
                    </Tooltip>
                );
            case 'message':
                return <span className={`${className} ${this.iconClass}`}>{this.message}</span>;
        }
    }

    @computed
    private get iconClass() {
        const { contract, display, isPortal } = this.props;
        if (!contract) {
            return 'text-warning';
        } else if (!this.warrantyPartStatus) {
            return 'text-orange';
        } else if (contract.demo) {
            return 'text-pink';
        } else if (!contract.inWarranty(display?.shippedDate)) {
            return 'text-warning';
        } else if (!contract.hasManagedServices && !isPortal) {
            return 'text-muted';
        } else {
            return 'text-success';
        }
    }

    @computed
    private get message() {
        const { contract, display, isPortal } = this.props;
        const partState = display?.partStatus?.partState;

        if (!contract) {
            return 'Not under a contract';
        } else if (!this.warrantyPartStatus) {
            return `Display Part Status: ${Enums.toString(Enums.PartState, partState)}`;
        } else if (contract.demo) {
            return 'Demo Contract';
        } else if (!contract.inWarranty(display?.shippedDate)) {
            return 'Your SmartVu® coverage has expired';
        } else if (!contract.active) {
            return 'Your SmartVu® contract is not active';
        } else if (!contract.hasManagedServices && !isPortal) {
            return 'Not Managed Services';
        } else if (contract.inWarranty(display?.shippedDate)) {
            return 'Active';
        } else {
            return 'Contract Inactive';
        }
    }

    @computed
    private get warrantyPartStatus() {
        switch (this.props.display?.partStatus?.partState) {
            case Mri.PartStatus.PartState.Discarded:
            case Mri.PartStatus.PartState.RMA:
            case Mri.PartStatus.PartState.Vandalized:
            case Mri.PartStatus.PartState.Maintenance:
            case Mri.PartStatus.PartState.ToBeDeleted:
            case Mri.PartStatus.PartState.Unpowered:
            case Mri.PartStatus.PartState.OutOfWarranty:
                return false;
            default:
                return true;
        }
    }
}
